import {createApp} from 'vue'
import App from './App.vue'
import './input.css'

const app = createApp(App);

app.mount('#app');
